import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { EnvironmentConfigurationService } from '../../services';
import { routes } from '../../../app.routes';

@Injectable({
  providedIn: 'root'
})
export class DashboardGuard implements CanActivate {
  constructor(private env: EnvironmentConfigurationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.env.environment.dashboardHidden) {
      // The dashboard is not activated via configuration param, forward the user to the product table route
      this.router.navigate([routes.products]);
      return false;
    } else {
      return true;
    }
  }
}
